import { GET_CELEBRATION_BY_IDENTITY } from '../graphql'
import { GetCelebrationByIdentityResponse } from './useGetCelebrationByIdentity'
import { useLazyQuery } from '@apollo/client'

export interface YbCelebrationByIdentityInput {
  input: {
    identityUuid: string
  }
}

export const useGetExistingCelebrationDataLazy = () => {
  const [getExistingCelebrations, { loading, error, data, refetch }] =
    useLazyQuery<
      GetCelebrationByIdentityResponse | undefined,
      YbCelebrationByIdentityInput
    >(GET_CELEBRATION_BY_IDENTITY, {
      errorPolicy: 'all',
    })

  return { getExistingCelebrations, loading, error, data, refetch }
}
